	import { message } from 'ant-design-vue';
	import i18n from '@/i18n'
	import { h } from 'vue';
	const methodMap = 
	[
	    [
            'requestFullscreen',
            'exitFullscreen',
            'fullscreenElement',
            'fullscreenEnabled',
            'fullscreenchange',
            'fullscreenerror'
	    ],
	    [
            'webkitRequestFullscreen',
            'webkitExitFullscreen',
            'webkitFullscreenElement',
            'webkitFullscreenEnabled',
            'webkitfullscreenchange',
            'webkitfullscreenerror'
	    ],
	    [
            'webkitRequestFullScreen',
            'webkitCancelFullScreen',
            'webkitCurrentFullScreenElement',
            'webkitCancelFullScreen',
            'webkitfullscreenchange',
            'webkitfullscreenerror'
	    ],
	    [
            'mozRequestFullScreen',
            'mozCancelFullScreen',
            'mozFullScreenElement',
            'mozFullScreenEnabled',
            'mozfullscreenchange',
            'mozfullscreenerror'
	    ],
	    [
            'msRequestFullscreen',
            'msExitFullscreen',
            'msFullscreenElement',
            'msFullscreenEnabled',
            'MSFullscreenChange',
            'MSFullscreenError'
	    ]
	];
	const nativeAPI = (() =>
	{
	    const _document = window.top.document
	    if (typeof _document === 'undefined')
	    {
	        return false;
	    }
	    const unprefixedMethods = methodMap[0];
	    const returnValue = {};
	    for (const methodList of methodMap)
	    {
	        const exitFullscreenMethod = methodList?.[1];
	        if (exitFullscreenMethod in _document)
	        {
	            for (const [index, method] of methodList.entries())
	            {
	                returnValue[unprefixedMethods[index]] = method;
	            }
	            return returnValue;
	        }
	    }
	    return false;
	})();
	const eventNameMap = {
	    'change': nativeAPI.fullscreenchange,
	    'error': nativeAPI.fullscreenerror
	};
	const checkIsF11FS = () =>
	{
	    const _window = window.top
	    return (_window.innerWidth === _window.screen.width && (_window.innerHeight === _window.screen.height || _window.outerHeight === _window.screen.height || (_window.innerHeight >= _window.outerHeight && _window.outerHeight > 0)))
	}
	const getIsScreenFull = () =>
	{
	    const userAgent = window.top.navigator.userAgent;
	    const _document = window.top.document
	    const _window = window.top
	    if (userAgent.indexOf('Mac OS') > -1)
	    {
	        return !!_document[nativeAPI.fullscreenElement] || (_window.innerWidth === _window.screen.width && (_window.innerHeight === _window.screen.height || _window.outerHeight === _window.screen.height || (_window.innerHeight >= _window.outerHeight && _window.outerHeight > 0)));
	    }
	    else 
	    {
	        if (nativeAPI && nativeAPI.fullscreenElement) 
	        {
	            if (_document[nativeAPI.fullscreenElement])
	            {
	                return true
	            }
	            else
	            {
	               return checkIsF11FS()
	            }
	        }
	        else
	        {
	            return !!_document[nativeAPI.fullscreenElement] || (_window.innerWidth === _window.screen.width && (_window.innerHeight === _window.screen.height || _window.outerHeight === _window.screen.height || (_window.innerHeight >= _window.outerHeight && _window.outerHeight > 0)));
	        }
	    }
	};
	let index = {
	    enter (element = window.top.document.documentElement, options)
	    {
	        return new Promise((resolve, reject) =>
	        {
	            const onFullScreenEntered = () =>
	            {
	                resolve();
	            };
	            const returnPromise = element[nativeAPI.requestFullscreen](options);
	            if (returnPromise instanceof window.top.Promise)
	            {
	                returnPromise.then(onFullScreenEntered).catch(reject);
	            }
	        });
	    },
	    exit ()
	    {
            return new Promise((resolve, reject) =>
            {
                if( nativeAPI && !window.top.document[nativeAPI.fullscreenElement] && checkIsF11FS())
                {
                    const getMessageContent = () => 
                    {
                        const { t: $t } = i18n.global;
                        return () =>
                            h(
                                'div', { class: 'fullscreen-tip-content' }, 
                                [
                                    $t('index.fullScreen.F11Exit'),
                                ],
                            )
                    }
                    message.open({
                        class: 'fullscreen-tip-box',
                        content: getMessageContent(),
                        icon: '',
                        duration: 3,
                    });
                    return false
                }
                const onFullScreenExit = () =>
                {
                resolve();
                };
                const _document = window.top.document
                const returnPromise = _document[nativeAPI.exitFullscreen]();
                if (returnPromise instanceof window.top.Promise)
                {
                    returnPromise.then(onFullScreenExit).catch(reject);
                }
            });
	    },
	    toggle (element, options)
	    {
	        return index.isFullscreen ? index.exit() : index.enter(element, options);
	    },
	    onchange (callback, immediate)
	    {
	        if(immediate)
	        {
	            if (callback)
	            {
	                callback(getIsScreenFull());
	            }
	        }
	        window.onresize = () =>
	        {
	            if (callback)
	            {
	                callback(getIsScreenFull());
	            }
	        };
	    },
	    onerror (callback)
	    {
	        index.on('error', callback);
	    },
	    on (event, callback)
	    {
            const eventName = eventNameMap[event];
            if (eventName)
            {
                document.addEventListener(eventName, callback, false);
            }
	    },
	    off (event, callback)
	    {
            const eventName = eventNameMap[event];
            if (eventName)
            {
                document.removeEventListener(eventName, callback, false);
            }
	    },
	    'raw': nativeAPI
	};
	Object.defineProperties(index, {
	    'isFullscreen': {
	        'get': () => getIsScreenFull()
	    },
	    'element': {
            'enumerable': true,
            'get': () => window.top.document[nativeAPI.fullscreenElement] ?? undefined
	    },
	    'isEnabled': {
            'enumerable': true,
            'get': () => Boolean(window.top.document[nativeAPI.fullscreenEnabled])
	    }
	});
	export default index;

